import appboy from '@braze/web-sdk';

const enabledCountries = ['CR', 'BO'];

const initializeBraze = () => {
  const key = process.env.REACT_APP_BRAZE_KEY;
  const url = process.env.REACT_APP_BRAZE_URL;
  if (key && url) {
    appboy.initialize(key, {
      baseUrl: url,
      enableLogging: true,
      manageServiceWorkerExternally: true,
    });
    registerInAppMessages();
    registerPushMessages();
    appboy.openSession();
  }
};

const setUserId = (userId) => {
  if (userId) appboy.changeUser(userId);
};

const showContentCards = () => {
  appboy.display.showContentCards();
};

const hideContentCards = () => {
  appboy.display.hideContentCards();
};

const getUnViewedCardCount = () => {
  return appboy.getCachedContentCards().getUnviewedCardCount();
};

const registerInAppMessages = () => {
  appboy.display.automaticallyShowNewInAppMessages();
};

const registerPushMessages = () => {
  if (appboy.isPushSupported()) appboy.registerAppboyPushMessages();
};

const getUser = () => {
  return appboy.getUser();
};

const subscribeToContentCardsUpdates = (callBack) => {
  return appboy.subscribeToContentCardsUpdates(callBack);
};

const removeSubscription = (id) => {
  appboy.removeSubscription(id);
};

export const brazeService = {
  enabledCountries,
  initializeBraze,
  setUserId,
  showContentCards,
  hideContentCards,
  getUnViewedCardCount,
  getUser,
  subscribeToContentCardsUpdates,
  removeSubscription,
};
